<template>
	<div class="open-account-userinfo">
		<van-form @submit="nextStep()">
			<div style="padding:20px;background-color: white;">
				<p v-html="text"></p>
				<van-checkbox-group v-model="checked">
					<van-checkbox style="margin-top: 10px;" :name="item.id" v-for="(item, index) in arr" :key="index">{{item.name}}</van-checkbox>
				</van-checkbox-group>
			</div>
			<div class="common_block">
				<van-button type="warning" block round native-type="submit">{{translate('userinfo_next_step')}}</van-button>
			</div>
			
		</van-form>
		
	</div>
</template>

<script>
	export default {
		name: 'account_statement',
		data() {
			return {
				token: "",
				text:'',
				arr:[],
				checked: [],

			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
				this.getquestion(5)
			}
		},
		methods: {
			getquestion(type) {
				this.$axios({
					method: 'post',
					url: 'account_open/getquestion',
					data: {
						filter_type:type
					}
				}).then ((res) => {
					if (res.success) {
						console.log(res.data[0].name)
						this.text=res.data[0].name
						this.arr=res.data[0].answers
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			},
			
			
			nextStep() {
				if(this.checked.length==3){
					this.$router.push('/account/signature?token=' + this.token)
				}else{
					this.$toast.fail('请先勾选同意协议')
				}
				
			}
		},
	}
</script>